type TQueueCb = () => void;

class RefQueue<T extends any> {
  public current: T | null;
  private queue: TQueueCb[];

  constructor() {
    this.current = null;

    this.queue = [];
  }

  private process = () => {
    if (!this.current) return;
    const fn = this.queue[0];

    if (fn) {
      fn();
      this.queue = [...this.queue.slice(1)];
      this.process();
    }
  };

  public refFn = (node: T | null) => {
    this.current = node;

    this.process();
  };

  public push = (fn: TQueueCb) => {
    this.queue.push(fn);
    this.process();
  };
}

export default RefQueue;
